import React, { Component } from "react";

import SearchQuestions from "../search/search_questions";

import CreateListUser from "./create_list_user";

import QuestionSelection from "../search/question/question_selection";

import { renderErrorMessage } from "../../helper/user_helper";
import { postList } from "../../helper/list_helper";

import Loader from "../loader";

import LocalizedStrings from "react-localization";
import en from "../../localization/localization-en.json";

let strings = new LocalizedStrings({ en });

class CreateList extends Component {
  state = {
    query: "",
    questionsSelected: [],
    listTitle: "",
    showSearch: true,
    errors: "",
    loaded: true
  };
  render() {
    if (this.state.loaded === false) {
      return <Loader loaded={false} />;
    }
    const style = {
      display: "block",
      position: "absolute",
      margin: "0px",
      width: "100%",
      height: "100%",
      textTransform: "capitalize"
    };
    const style_image = {
      position: "absolute",
      right: "-10px",
      bottom: "-5px"
    };
    return (
      <form onSubmit={this.createList}>
        <div className="pt-2">
          <CreateListUser
            user={this.props.user}
            handleChangeTitle={this.handleChangeTitle}
            listTitle={this.state.listTitle}
            questionsSelected={this.state.questionsSelected}
            showSearch={this.state.showSearch}
            handleChangeSeachToList={this.handleChangeSeachToList}
          />
          {renderErrorMessage(this.state.errors)}
          {this.renderBottomView()}
          <div className="row max_width_500 bottom_right width_100">
            <div className="width_image_question" />
            <div className="width_text_question" />
            <div className="width_image_question">
              <div className="user_img" style={style_image}>
                <input
                  style={style}
                  type="submit"
                  value={strings.post}
                  className="btn btn_primary btn_yaystack no_border"
                />
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  }

  renderBottomView() {
    if (this.state.showSearch === false) {
      var questions = this.state.questionsSelected.map(question => {
        return (
          <QuestionSelection
            key={question.id}
            question={question}
            questionsSelected={this.state.questionsSelected}
            unselectQuestion={this.unselectQuestion}
            selectQuestion={this.selectQuestion}
          />
        );
      });
      return <div>{questions}</div>;
    } else {
      return (
        <React.Fragment>
          <input
            type="text"
            className="width_100 yaystack_input_text search_input"
            value={this.state.query}
            onChange={this.handleChangeQuery}
            placeholder="Search"
          />
          <SearchQuestions
            query={this.state.query}
            selectQuestion={this.selectQuestion}
            unselectQuestion={this.unselectQuestion}
            questionsSelected={this.state.questionsSelected}
          />
        </React.Fragment>
      );
    }
  }

  handleChangeQuery = event => {
    this.setState({ query: event.target.value });
  };

  handleChangeTitle = event => {
    this.setState({ listTitle: event.target.value });
  };

  handleChangeSeachToList = event => {
    const showSearch = !this.state.showSearch;
    this.setState({ showSearch });
  };

  selectQuestion = question => {
    const questionsSelected = [...this.state.questionsSelected];
    questionsSelected.push(question);
    this.setState({ questionsSelected });
  };

  unselectQuestion = question => {
    const questionsSelected = [...this.state.questionsSelected];
    for (var questionSelected_id in questionsSelected) {
      if (questionsSelected[questionSelected_id].id === question.id) {
        questionsSelected.splice(questionSelected_id, 1);
        break;
      }
    }
    this.setState({ questionsSelected });
  };

  createList = event => {
    event.preventDefault();

    if (this.state.listTitle === "") {
      this.setState({ errors: "You need a title." });
      return;
    }

    if (this.state.questionsSelected.length === 0) {
      this.setState({ errors: "You need to add questions." });
      return;
    }
    this.setState({ loaded: false });
    const self = this;

    var fd = new FormData();
    fd.append("list[title]", this.state.listTitle);
    var listArray = [];
    for (var i = 0; i < this.state.questionsSelected.length; i++) {
      listArray.push(this.state.questionsSelected[i].id);
    }
    fd.append("list[questions]", listArray.join());
    this.postListCall = postList(fd);
    this.postListCall.promise
      .then(answer => {
        self.props.history.push("/");
      })
      .catch(error => {
        self.setState({ loaded: true, errors: error.errors });
      });
  };
}

export default CreateList;



// WEBPACK FOOTER //
// ./src/components/create_list/create_list.jsx